import { Component, EventEmitter, Input, Output } from '@angular/core';
import { hyperlinkOpenIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { DocumentService } from '../../services/document.service';
import { AssignedDocument } from '../../models/assigned-document';
import { TaskNotification } from '../../models/task-notification';

@Component({
	selector: 'kpa-link',
	templateUrl: './link.component.html',
	styleUrl: './link.component.scss',
})
export class LinkComponent {
	@Input() dialogOpened: boolean = false;
	@Input() documentTitle: string;
	@Input() linkUrl: string;
	@Input() documentId: string;
	@Output() dialogOpenedChange: EventEmitter<string> = new EventEmitter<string>();
	@Output() closeDialog = new EventEmitter();
	@Output() onTaskComplete: EventEmitter<TaskNotification> = new EventEmitter<TaskNotification>();
	isReadDocEnabled: boolean = false;
	showErrorMsg: boolean = false;
	constructor(private documentService: DocumentService) {}

	public hyperlinkOpenIcon: SVGIcon = hyperlinkOpenIcon;

	public openLink(url: string) {
		window.open(url, '_blank');
		this.isReadDocEnabled = true;
	}
	public completeTraining(documentId: string) {
		if (!this.isReadDocEnabled) {
			this.showErrorMsg = true;
			return;
		}
		this.documentService.completeTraining(documentId).subscribe((result: AssignedDocument) => {
			if (result) {
				const taskNotification: TaskNotification = {
					isCompleted: true,
					isReviewed: false,
				};
				this.dialogOpenedChange.emit();
				this.onTaskComplete.emit(taskNotification);
				this.dialogOpened = false;
				this.isReadDocEnabled = false;
				this.showErrorMsg = false;
			}
		});
	}
	public open(component: string): void {
		this[component + 'Opened'] = true;
	}

	public close(component: string): void {
		this[component + 'Opened'] = false;
		this.isReadDocEnabled = false;
		this.showErrorMsg = false;
		this.closeDialog.emit();
	}
}
